import { Item } from 'react-stately';

import type IReactStately from 'react-stately';

interface ITabsItem {
  <T>(props: IReactStately.ItemProps<T> & ICustomizable): JSX.Element;
}

export const TabsItem = Item as ITabsItem;
